export const epg = [
  {
    id: "6f3caa7f-5b11-4edb-998e-80d4baa03373",
    description:
      "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
    title: "The Book of Boba Fett",
   isYesterday: false,
    since: "2022-12-29T23:50:00",
    till: "2022-12-29T00:55:00",
    channelUuid: "16fdfefe-e466-4090-bc1a-57c43937f826",
    image:
      "https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg",
    country: "Ghana",
    Year: "2021–",
    Rated: "TV-14",
    Released: "29 Dec 2021",
    Runtime: "N/A",
    Genre: "Action, Adventure, Sci-Fi",
    Director: "N/A",
    Writer: "Jon Favreau",
    Actors: "Temuera Morrison, Ming-Na Wen, Matt Berry",
    Language: "English",
    Country: "United States",
  },
  {
    id: "10990617-c229-4d1e-b341-7fe100b36b3c",
    description:
      "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
    title: "The Book of Light",
   isYesterday: false,
    since: "2022-10-29T08:15:00Z",
    till: "2022-10-29T09:00:00Z",
    channelUuid: "16fdfefe-e466-4090-bc1a-57c43937f826",
    image:
      "https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg",
    country: "Ghana",
    Year: "2021–",
    Rated: "TV-14",
    Released: "29 Dec 2021",
    Runtime: "N/A",
    Genre: "Action, Adventure, Sci-Fi",
    Director: "N/A",
    Writer: "Jon Favreau",
    Actors: "Temuera Morrison, Ming-Na Wen, Matt Berry",
    Language: "English",
    Country: "United States",
  },
  {
    id: "00990617-c229-4d1e-b341-7fe100b36b3c",
    description:
      "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
    title: "The Book of Ashoka",
   isYesterday: false,
    since: "2022-10-29T09:15:00Z",
    till: "2022-10-29T10:20:00Z",
    channelUuid: "16fdfefe-e466-4090-bc1a-57c43937f826",
    image:
      "https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg",
    country: "Ghana",
    Year: "2021–",
    Rated: "TV-14",
    Released: "29 Dec 2021",
    Runtime: "N/A",
    Genre: "Action, Adventure, Sci-Fi",
    Director: "N/A",
    Writer: "Jon Favreau",
    Actors: "Temuera Morrison, Ming-Na Wen, Matt Berry",
    Language: "English",
    Country: "United States",
  },
  {
    id: "20990617-c229-4d1e-b341-7fe100b36b3c",
    description:
      "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
    title: "The Book of Ashoka",
   isYesterday: false,
    since: "2022-12-29T10:25:00Z",
    till: "2022-12-29T12:20:00Z",
    channelUuid: "16fdfefe-e466-4090-bc1a-57c43937f826",
    image:
      "https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg",
    country: "Ghana",
    Year: "2021–",
    Rated: "TV-14",
    Released: "29 Dec 2021",
    Runtime: "N/A",
    Genre: "Action, Adventure, Sci-Fi",
    Director: "N/A",
    Writer: "Jon Favreau",
    Actors: "Temuera Morrison, Ming-Na Wen, Matt Berry",
    Language: "English",
    Country: "United States",
  },
  {
    id: "23990617-c229-4d1e-b341-7fe100b36b3c",
    description:
      "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
    title: "The Book of Ashoka 2",
   isYesterday: false,
    since: "2022-12-29T12:25:00Z",
    till: "2022-12-29T14:20:00Z",
    channelUuid: "16fdfefe-e466-4090-bc1a-57c43937f826",
    image:
      "https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg",
    country: "Ghana",
    Year: "2021–",
    Rated: "TV-14",
    Released: "29 Dec 2021",
    Runtime: "N/A",
    Genre: "Action, Adventure, Sci-Fi",
    Director: "N/A",
    Writer: "Jon Favreau",
    Actors: "Temuera Morrison, Ming-Na Wen, Matt Berry",
    Language: "English",
    Country: "United States",
  },
  {
    id: "26990617-c229-4d1e-b341-7fe100b36b3c",
    description:
      "Bounty hunter Boba Fett & mercenary Fennec Shand navigate the underworld when they return to Tatooine to claim Jabba the Hutt's old turf.",
    title: "The Book of Ashoka 3",
   isYesterday: false,
    since: "2022-12-29T14:25:00Z",
    till: "2022-12-29T20:20:00Z",
    channelUuid: "16fdfefe-e466-4090-bc1a-57c43937f826",
    image:
      "https://www.themoviedb.org/t/p/w1066_and_h600_bestv2/sjx6zjQI2dLGtEL0HGWsnq6UyLU.jpg",
    country: "Ghana",
    Year: "2021–",
    Rated: "TV-14",
    Released: "29 Dec 2021",
    Runtime: "N/A",
    Genre: "Action, Adventure, Sci-Fi",
    Director: "N/A",
    Writer: "Jon Favreau",
    Actors: "Temuera Morrison, Ming-Na Wen, Matt Berry",
    Language: "English",
    Country: "United States",
  }

];
